import { ProjectSearchContentEntity } from 'src/types'

export const useSearchContent = () => {
  const loadEnabledSearchContent = (searchContent: ProjectSearchContentEntity): boolean => {
    return (
      (!!searchContent.word && searchContent.word !== '') ||
      !!searchContent.startDate ||
      !!searchContent.endDate ||
      (!!searchContent.selectedStatuses && searchContent.selectedStatuses.length > 0) ||
      (!!searchContent.selectedPrefectures && searchContent.selectedPrefectures?.length > 0)
    )
  }

  return { loadEnabledSearchContent }
}
